import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import asyncLoading from 'react-async-loader';

const StreetView = ({
    apiKey,
    streetViewPanoramaOptions = {
        position: { lat: 30.41881800, lng: -87.20564000 },
        pov: { heading: 0, pitch: 0 },
        zoom: 1
    },
    googleMaps,
}) => {
    const [isNoData, setIsNoData] = useState(false);
    const streetViewRef = useRef(null);
    const streetView = useRef(null);

    const initialize = (canvas) => {
        if (googleMaps && streetView.current == null) {
            const location = {
                lat: streetViewPanoramaOptions.position.lat,
                lng: streetViewPanoramaOptions.position.lng
            };

            const svService = new googleMaps.StreetViewService();
            const panoRequest = {
                location: location,
                preference: googleMaps.StreetViewPreference.NEAREST,
                radius: 50,
                source: googleMaps.StreetViewSource.OUTDOOR
            };

            const findPanorama = (radius) => {
                panoRequest.radius = radius;
                svService.getPanorama(panoRequest, (panoData, status) => {
                    if (status === googleMaps.StreetViewStatus.OK) {
                        streetView.current = new googleMaps.StreetViewPanorama(
                            canvas,
                            {
                                pano: panoData.location.pano,
                            }
                        );
                    } else {
                        if (radius > 200) {
                            setIsNoData(true);
                        } else {
                            findPanorama(radius + 5);
                        }
                    }
                });
            };

            findPanorama(50);
        }
    };

    useEffect(() => {
        if (googleMaps) { // Ensure googleMaps is loaded before initializing
            initialize(ReactDOM.findDOMNode(streetViewRef.current));

            return () => {
                if (streetView.current && googleMaps.event) {
                    googleMaps.event.clearInstanceListeners(streetView.current);
                }
            };
        }
    }, [googleMaps, streetViewPanoramaOptions]);

    if (!googleMaps) {
        return <div>Loading Google Maps...</div>; // Or some other loading indicator
    }

    return (
        <div
            style={{
                height: isNoData ? '130px' : '450px',
            }}
            ref={streetViewRef}
        >
            <p className="no-data" style={{ position: 'relative', top: isNoData ? '25px' : '0' }}>
                {isNoData ? "Street view is not available for this location." : "Loading data..."}
            </p>
        </div>
    );
};


function mapScriptsToProps(props) {
    const googleMapsApiKey = props.apiKey;
    return {
        googleMaps: {
            globalPath: 'google.maps',
            url: `https://maps.googleapis.com/maps/api/js?key=${googleMapsApiKey}&callback=initialize`,
            jsonp: true
        }
    };
}

export default asyncLoading(mapScriptsToProps)(StreetView);
